import isDarkCode from 'src/common/utils/isDarkCode';

export const allowedProductionOwnerIds = [
  123315,
  114336,
  225076,
  129476,
  1171992,
  383312,
  1131114,
  257899,
  1231141,
  644240,
];

const isCalendarSyncAllowed = (userId?: number, isStaff?: boolean) => {
  const isProduction = !isDarkCode();

  if (!userId) return false;
  if (!isProduction) return true;
  if (isProduction && isStaff) return true;
  if (isProduction && allowedProductionOwnerIds.includes(userId)) return true;
  return false;
};

export default isCalendarSyncAllowed;
